import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { ResponseObject } from 'src/app/models/response-object.model';
import { OrderReservationService } from 'src/app/services/order-reservation.service';
import { DateUtil } from 'src/app/common/util';
import { OrderReservationStatus } from 'src/app/enums/order-reservation-status.enum';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';

@Component({
  selector: 'app-history-order-reservation',
  templateUrl: './history-order-reservation.component.html',
  styleUrls: ['./history-order-reservation.component.scss']
})
export class HistoryOrderReservationComponent implements OnInit {
  reservations: any[] = [];
  reservationDetails: any[] = [];

  pagination = {
    total: [] as any[],
    filter: [] as any[],
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };

  search = '';
  startDate = '';
  endDate = '';
  statusFilter = '';

  loading = false;
  detailLoading = false;
  reservationDetail: any = null;

  showModalDetail = false;

  statuses = OrderReservationStatus;

  warehouses: WarehouseResponse[] = [];
  selectedWarehouse = null;

  showGroupedModal = false;
  groupedLoading = false;
  groupedReservations: any[] = [];

  showPurchaseOrderModal = false;
  purchaseOrderData: any = null;
  purchaseOrderLoading = false;

  statusOptions = [
    { key: 'RESERVED', label: OrderReservationStatus.RESERVED, color: 'bg-info' },
    { key: 'DONE', label: OrderReservationStatus.DONE, color: 'bg-success' },
    { key: 'TO_CONFIRMED', label: OrderReservationStatus.TO_CONFIRMED, color: 'bg-warning' },
    { key: 'EXPIRED', label: OrderReservationStatus.EXPIRED, color: 'bg-danger' },
    { key: 'CANCELLED', label: OrderReservationStatus.CANCELLED, color: 'bg-secondary' },
  ];

  constructor(
    private reservationService: OrderReservationService,
    private warehouseService: WarehouseService,
    private toastService: ToastrService,
  ) {
    const today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.startDate = today.toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.getReservations();
    this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouses().subscribe(
      {
        next: (response: ResponseObject) => {
          this.warehouses = response.data as WarehouseResponse[];
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      }
    );
  }

  getReservations() {
    this.loading = true;
    const oneDayMs = 24 * 60 * 60 * 1000;
    const endDatePlusOneDay = DateUtil.parseDateToMilliseconds(this.endDate) + oneDayMs;

    this.reservationService
      .getReservations(
        DateUtil.parseDateToMilliseconds(this.startDate),
        endDatePlusOneDay
      )
      .subscribe({
        next: (response: ResponseObject) => {
          this.loading = false;
          this.reservations = (response.data || []).map((r: any) => ({
            ...r,
            clientName: r.clientData?.name || 'Sin cliente',
            warehouseName: r.warehouseData?.name || '-',
            userName: r.userName || '-',
          }));

          this.reservations.sort((a, b) => {
            const dateA = new Date(a.reservedDate).getTime();
            const dateB = new Date(b.reservedDate).getTime();
            return dateB - dateA;
          });

          this.pagination.total = this.reservations;
          this.resetPagination();
          this.searching();
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          this.toastService.error(error.error?.message || 'Error al obtener reservaciones');
        }
      });
  }

  showDetails(reservation: any) {
    this.reservationDetail = reservation;
    this.showModalDetail = true;
    this.detailLoading = true;
    this.reservationDetails = [];

    this.reservationService.getReservationDetail(reservation.id).subscribe({
      next: (response: any) => {
        this.reservationDetails = response.data || [];
        this.detailLoading = false;
      },
      error: () => {
        this.detailLoading = false;
        this.toastService.error('Error al obtener los detalles de la reservación');
      }
    });
  }

  resetPagination() {
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.lastElement = this.pagination.filter.length;
  }

  searching() {
    const term = this.search.trim().toLowerCase();
    this.pagination.total = this.reservations.filter((r) => this.matchValue(r, term));
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
  }

  filterByStatus() {
    this.pagination.total = this.reservations.filter((r) =>
      this.statusFilter ? r.status === this.statusFilter : true
    );
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
  }

  matchValue(r: any, value: string): boolean {
    if (!value) return true;
    return (
      (r.number && r.number.toString().includes(value)) ||
      (r.clientName && r.clientName.toLowerCase().includes(value)) ||
      (r.warehouseName && r.warehouseName.toLowerCase().includes(value)) ||
      (r.status && r.status.toLowerCase().includes(value))
    );
  }

  checkDateValue() {
    if (this.startDate && this.endDate) this.getReservations();
  }

  closeDetails(refresh:any) {
    this.showModalDetail = false;
    this.reservationDetail = null;
    this.reservationDetails = [];
    console.log(refresh);
    if(refresh == true){
      this.getReservations();
      console.log("recargando");
    }
  }

  getReservationTotal(): number {
    if (!this.reservationDetails || this.reservationDetails.length === 0) return 0;
    return this.reservationDetails
      .map((d: any) => Number(d.quantity || 0) * Number(d.price || 0))
      .reduce((a: number, b: number) => a + b, 0);
  }

  getStatusColor(status: string): string {
    const option = this.statusOptions.find(s => s.label === status);
    return option ? option.color : 'bg-secondary';
  }

  confirmReservation(reservation: any) {
    if (!reservation?.id) return;

    this.reservationService.confirmReservation(reservation.id).subscribe({
      next: () => {
        this.toastService.success('Reservación confirmada correctamente.');
        reservation.status = this.statuses.RESERVED;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al confirmar la reservación');
      }
    });
  }

  cancelReservation(reservation: any) {
    if (!reservation?.id) return;

    this.reservationService.cancelReservation(reservation.id).subscribe({
      next: () => {
        this.toastService.warning('Reservación cancelada correctamente.');
        reservation.status = this.statuses.CANCELLED;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al cancelar la reservación');
      }
    });
  }

  searchGrouped() {
    if (!this.selectedWarehouse) {
      this.toastService.error('Debe seleccionar una bodega antes de agrupar');
      return;
    }

    this.groupedLoading = true;

    this.reservationService
      .getGroupedReservations(
        DateUtil.parseDateToMilliseconds(this.startDate),
        DateUtil.parseDateToMilliseconds(this.endDate),
        this.selectedWarehouse.id
      )
      .subscribe({
        next: (response: ResponseObject) => {
          this.groupedReservations = [response.data]; // si es un objeto, no un array
          console.log("gr", this.groupedReservations);
          this.groupedLoading = false;
          this.showGroupedModal = true;
        },
        error: (error) => {
          this.groupedLoading = false;
          this.toastService.error(error.error?.message || 'Error al obtener la agrupación');
        },
      });
  }

  closeGroupedModal(refresh:any) {
    this.showGroupedModal = false;
    if(refresh == true){
      this.getReservations();
    }
  }

  createPurchaseOrderFromReservation(reservation: any) {

    if (!reservation?.id) {
        return;
    }

    this.purchaseOrderLoading = true;

    this.reservationService.getReservationDetail(reservation.id).subscribe({

        next: (response: ResponseObject) => {

            this.purchaseOrderLoading = false;

            this.purchaseOrderData = {
                reservation: reservation,
                details: response.data || []
            };

            this.showPurchaseOrderModal = true;
        },

        error: (error: HttpErrorResponse) => {

            this.purchaseOrderLoading = false;

            this.toastService.error(
                error.error?.message ||
                'Error al obtener los detalles de la reservación'
            );
        }

    });
  }

  closePurchaseOrderModal(refresh: boolean) {
    this.showPurchaseOrderModal = false;
    this.purchaseOrderData = null;

    if (refresh) {
        this.getReservations();
    }
  }




}
